/* CUBE Clean — progressive enhancement. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---------- Mobile nav drawer ---------- */
  function initDrawer() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!toggle || !drawer) return;
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }
    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      // simple focus trap
      var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    toggle.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
  }

  /* ---------- Accordion ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (acc) {
      acc.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('.accordion__item');
          var expanded = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', String(!expanded));
          item.classList.toggle('is-open', !expanded);
          var icon = trigger.querySelector('.accordion__icon');
          if (icon) icon.textContent = expanded ? '+' : '–';
        });
      });
    });
  }

  /* ---------- Segmented controls (purchase toggle, scent) ---------- */
  function initSegmented() {
    document.querySelectorAll('[data-segmented]').forEach(function (group) {
      var input = group.parentNode.querySelector('input[type="hidden"]');
      group.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          group.querySelectorAll('.segmented__option').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-pressed', 'true');
          if (input) input.value = opt.getAttribute('data-value') || opt.textContent.trim();
          var err = group.parentNode.querySelector('[data-scent-error]');
          if (err) err.hidden = true;
        });
      });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var v = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Product form: variant + selling-plan selection ---------- */
  function initProductForm() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var variantsEl = form.querySelector('[data-variants]');
    var pricesEl = form.querySelector('[data-variant-prices]');
    var planPricesEl = form.querySelector('[data-plan-prices]');
    var preorderEl = form.querySelector('[data-variant-preorder]');
    var variants = [];
    var prices = {};       // variantId -> one-time formatted price
    var planPrices = {};   // "variantId:planId" -> subscription formatted price
    var preorderMap = {};  // variantId -> true if pre-order (out of stock, continue selling)
    var variantMediaEl = form.querySelector('[data-variant-media]');
    var variantMedia = {}; // variantId -> assigned media id (or null)
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    var priceCents = {}; variants.forEach(function (v) { priceCents[v.id] = v.price; }); // variantId -> price in cents
    try { preorderMap = JSON.parse(preorderEl.textContent); } catch (e) {}
    try { variantMedia = JSON.parse(variantMediaEl.textContent); } catch (e) {}

    // Switch the gallery to a given media id (used when a variant with an assigned image is chosen).
    function activateMedia(mediaId) {
      if (mediaId == null) return;
      var box = document.querySelector('[data-gallery-main]');
      if (!box) return;
      var sid = String(mediaId), found = false;
      box.querySelectorAll('.gallery-item').forEach(function (it) {
        var m = it.getAttribute('data-media-id') === sid;
        if (m) found = true;
        it.hidden = !m;
        var v = it.querySelector('video');
        if (v) { if (m && v.play) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else if (v.pause) v.pause(); }
      });
      if (!found) return;
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-media-id') === sid);
      });
    }
    try { prices = JSON.parse(pricesEl.textContent); } catch (e) {}
    try {
      JSON.parse(planPricesEl.textContent).forEach(function (e) { planPrices[e.v + ':' + e.p] = e.price; });
    } catch (e) {}

    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var perLoadEl = document.querySelector('[data-price-per-load]');
    var loadsForPrice = perLoadEl ? (parseInt(perLoadEl.getAttribute('data-loads'), 10) || 0) : 0;
    var addBtn = form.querySelector('[data-add]');
    var subscribeBtn = form.querySelector('[data-subscribe]');
    var refillFlag = form.querySelector('[data-refill-flag]');
    var preorderNote = form.querySelector('[data-preorder-note]');
    // "Pre-order & Subscribe" submits the same cart add plus the Un-Subscription refill-reminder property
    // (no recurring charge). The property is disabled by default so a plain Pre-order never includes it;
    // enable it only when the subscribe button is the one used (and re-disable if they switch back).
    if (subscribeBtn && refillFlag) subscribeBtn.addEventListener('click', function () { refillFlag.disabled = false; });
    if (addBtn && refillFlag) addBtn.addEventListener('click', function () { refillFlag.disabled = true; });
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]'));

    var currentVariantId = idInput ? idInput.value : null;
    var currentPlan = '';

    function renderPrice() {
      if (!priceEl) return;
      var planKey = currentVariantId + ':' + currentPlan;
      if (currentPlan && planPrices[planKey]) { priceEl.textContent = planPrices[planKey]; }
      else if (prices[currentVariantId]) { priceEl.textContent = prices[currentVariantId]; }
      if (perLoadEl && loadsForPrice > 0 && priceCents[currentVariantId] != null) {
        perLoadEl.textContent = 'as low as $' + (priceCents[currentVariantId] / loadsForPrice / 100).toFixed(2) + '/load';
      }
    }

    function selectOne(group, opt) {
      group.querySelectorAll('.segmented__option').forEach(function (o) {
        o.classList.remove('is-selected'); o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-selected'); opt.setAttribute('aria-pressed', 'true');
    }
    function selectedValues() {
      return optionGroups.map(function (g) {
        var s = g.querySelector('.is-selected');
        return s ? s.getAttribute('data-value') : null;
      });
    }
    function eq(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) { if (String(a[i]) !== String(b[i])) return false; }
      return true;
    }
    function allSelected() {
      return optionGroups.length > 0 && optionGroups.every(function (g) { return g.querySelector('.is-selected'); });
    }
    function setAdd(enabled, label) {
      if (subscribeBtn) subscribeBtn.disabled = !enabled;
      if (!addBtn) return;
      addBtn.disabled = !enabled;
      if (label) addBtn.innerHTML = label;
    }
    function updateVariant() {
      if (!variants.length || !optionGroups.length) return;
      // A default option is pre-selected server-side (e.g. Unscented); if a shopper clears it, keep disabled until every option is chosen again.
      if (!allSelected()) {
        currentVariantId = null;
        if (idInput) idInput.value = '';
        setAdd(false, 'Add to cart <span aria-hidden="true">→</span>');
        if (preorderNote) preorderNote.hidden = true;
        return;
      }
      var sel = selectedValues();
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (eq(variants[i].options, sel)) { match = variants[i]; break; }
      }
      if (!match) { currentVariantId = null; if (idInput) idInput.value = ''; setAdd(false, 'Unavailable'); if (preorderNote) preorderNote.hidden = true; return; }
      currentVariantId = match.id;
      if (idInput) idInput.value = match.id;
      renderPrice();
      // Pre-order = buyable at <=0 tracked inventory (i.e. "continue selling when out of stock").
      var isPreorder = !!preorderMap[match.id];
      if (match.available) {
        setAdd(true, isPreorder ? 'Pre-order <span aria-hidden="true">→</span>' : 'Add to cart <span aria-hidden="true">→</span>');
        if (subscribeBtn) subscribeBtn.innerHTML = isPreorder ? 'Pre-order &amp; Subscribe' : 'Add &amp; Subscribe';
      } else {
        setAdd(false, 'Sold out');
        if (subscribeBtn) subscribeBtn.innerHTML = 'Sold out';
      }
      if (preorderNote) preorderNote.hidden = !isPreorder;
      activateMedia(variantMedia[match.id]); // swap gallery to the selected variant's image
      if (typeof renderCalc === 'function') renderCalc(); // refresh estimate with this variant's pack size
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () { selectOne(group, opt); updateVariant(); });
      });
    });
    updateVariant(); // initial state: disabled until a variant is picked

    // Purchase type: one-time vs The Un-Subscription (refill reminders — no auto-charge).
    // The "on" option enables a line-item property so a Klaviyo flow can send a reorder reminder.
    var ptGroup = form.querySelector('[data-purchase-type] .segmented');
    var reminderInput = form.querySelector('[data-reminder-input]');
    var ptPanel = form.querySelector('[data-pt-panel]');
    var freqInput = form.querySelector('[data-calc-freq-input]');
    var windowInput = form.querySelector('[data-calc-window-input]');
    var bucketInput = form.querySelector('[data-calc-bucket-input]');
    function setReminder(on) {
      if (reminderInput) reminderInput.disabled = !on;
      if (freqInput) freqInput.disabled = !on;
      if (windowInput) windowInput.disabled = !on;
      if (bucketInput) bucketInput.disabled = !on;
      if (ptPanel) ptPanel.hidden = !on;
    }
    if (ptGroup) {
      ptGroup.querySelectorAll('.segmented__option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          selectOne(ptGroup, opt);
          setReminder(opt.getAttribute('data-reminder') === 'on');
        });
      });
      var ptSel = ptGroup.querySelector('.is-selected');
      setReminder(!!ptSel && ptSel.getAttribute('data-reminder') === 'on');
    }

    // Refill calculator: dish frequency -> estimated reminder date
    var calcSel = form.querySelector('[data-calc-frequency]');
    var calcOut = form.querySelector('[data-calc-result]');
    if (calcSel && calcOut) {
      var defaultLoads = parseInt(calcSel.getAttribute('data-loads'), 10) || 64;
      var currentLoads = function () {
        // Loads per box from the SELECTED variant's name (e.g. "… / 32 Pack" -> 32); else the default.
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(currentVariantId)) {
            var m = String(variants[i].title || '').match(/(\d[\d,]*)/);
            return m ? parseInt(m[1].replace(/,/g, ''), 10) : defaultLoads;
          }
        }
        return defaultLoads;
      };
      var renderCalc = function () {
        var every = parseInt(calcSel.value, 10) || 1;
        var loads = currentLoads();
        var d = new Date();
        d.setDate(d.getDate() + (every * loads));
        calcOut.textContent = 'We’ll remind you around ' +
          d.toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) + '.';
        // Log the answer on the order (line-item properties)
        var label = calcSel.options[calcSel.selectedIndex] ? calcSel.options[calcSel.selectedIndex].text : calcSel.value;
        if (freqInput) freqInput.value = 'every ' + label;
        if (windowInput) windowInput.value = '~' + (every * loads) + ' days';
        if (bucketInput) bucketInput.value = (every <= 2) ? 'Frequent' : 'Occasional';
      };
      calcSel.addEventListener('change', renderCalc);
      renderCalc();
    }
  }

  /* ---------- Password page: submit sample request to Klaviyo (client API) ---------- */
  function initPasswordForm() {
    var form = document.querySelector('[data-password-form]');
    if (!form) return;

    // Scent is required (no default). This guard is registered first, so on submit it runs before
    // the Klaviyo handler below and before any native POST — blocking both if no scent is chosen.
    var scentEl = form.querySelector('[data-required-scent]');
    if (scentEl) {
      form.addEventListener('submit', function (e) {
        if (!scentEl.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var scentErr = form.querySelector('[data-scent-error]');
          if (scentErr) scentErr.hidden = false;
          var grp = form.querySelector('[data-segmented]');
          if (grp && grp.scrollIntoView) grp.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      });
    }

    var key = form.getAttribute('data-klaviyo-key');
    var list = form.getAttribute('data-klaviyo-list');
    if (!key || !list) return; // not Klaviyo — let the form POST to its action

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
      var consentEl = form.querySelector('[name="marketing_consent"]');
      var subscribed = !!(consentEl && consentEl.checked);
      var smsEl = form.querySelector('[name="sms_consent"]');
      var smsOptedIn = !!(smsEl && smsEl.checked);

      // Normalize phone to E.164 (US/CA) so Klaviyo accepts it; keep the raw entry as a property too.
      var rawPhone = val('phone');
      var phoneDigits = rawPhone.replace(/\D/g, '');
      var phoneE164 = '';
      if (phoneDigits.length === 10) { phoneE164 = '+1' + phoneDigits; }
      else if (phoneDigits.length === 11 && phoneDigits.charAt(0) === '1') { phoneE164 = '+' + phoneDigits; }

      var profile = {
        email: val('email'),
        first_name: val('first_name'),
        last_name: val('last_name'),
        properties: { 'Scent preference': val('scent'), 'Phone': rawPhone, 'SMS consent': (smsOptedIn ? 'Yes' : 'No'), 'Pre-order': true, 'Source': 'Reserve my pre-order' }
      };
      if (phoneE164) { profile.phone_number = phoneE164; }

      var endpoint, body;
      if (subscribed) {
        endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key);
        body = { data: { type: 'subscription', attributes: { custom_source: 'Reserve my pre-order', profile: { data: { type: 'profile', attributes: profile } } }, relationships: { list: { data: { type: 'list', id: list } } } } };
      } else {
        endpoint = 'https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(key);
        body = { data: { type: 'profile', attributes: profile } };
      }

      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
        .then(function (r) {
          if (r.ok) {
            var success = form.querySelector('[data-form-success]');
            Array.prototype.forEach.call(form.children, function (c) { if (c !== success) c.style.display = 'none'; });
            if (success) success.hidden = false;
          } else {
            r.text().then(function (t) { try { console.error('[CUBE] Klaviyo error', r.status, t); } catch (e) {} });
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
            alert('Sorry — something went wrong. Please try again.');
          }
        })
        .catch(function (err) {
          try { console.error('[CUBE] Klaviyo request failed', err); } catch (e) {}
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
          alert('Sorry — something went wrong. Please try again.');
        });
    });
  }

  /* ---------- Sticky add-to-cart bar (conversion LPs) ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar) return;
    var form = document.getElementById('product-form');
    var mainBtn = form ? form.querySelector('[data-add]') : null;
    if (!form || !mainBtn) return;
    var stickyBtn = bar.querySelector('[data-sticky-btn]');
    var stickyPrice = bar.querySelector('[data-sticky-price]');
    var mainPrice = document.querySelector('[data-price]');

    // Mirror the main button (label + disabled) and price — updateVariant maintains those.
    function sync() {
      if (stickyBtn) { stickyBtn.innerHTML = mainBtn.innerHTML; stickyBtn.disabled = mainBtn.disabled; }
      if (stickyPrice && mainPrice) stickyPrice.textContent = mainPrice.textContent;
    }
    sync();
    if (window.MutationObserver) {
      var mo = new MutationObserver(sync);
      mo.observe(mainBtn, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      if (mainPrice) mo.observe(mainPrice, { childList: true, characterData: true, subtree: true });
    }

    // Show the bar once the buy box has scrolled up out of view.
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }, { threshold: 0 });
      io.observe(form);
    } else {
      bar.hidden = false;
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainBtn.disabled) {
          form.scrollIntoView({ block: 'center', behavior: 'smooth' }); // needs a scent picked
          return;
        }
        mainBtn.click();
      });
    }
  }

  /* ---------- The Truth video carousel ---------- */
  function initTruthCarousel() {
    document.querySelectorAll('[data-truth-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-truth-track]');
      if (!track) return;
      function step() { var c = track.querySelector('.truth-card'); return c ? c.offsetWidth + 16 : track.clientWidth * 0.8; }
      var prev = car.querySelector('[data-truth-prev]');
      var next = car.querySelector('[data-truth-next]');
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      // Only play the video(s) currently in view — saves bandwidth with several clips.
      var vids = track.querySelectorAll('video');
      if (window.IntersectionObserver && vids.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) { var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); }
            else if (v.pause) v.pause();
          });
        }, { root: track, threshold: 0.5 });
        vids.forEach(function (v) { io.observe(v); });
      }
    });
  }

  /* ---------- Announcement marquee ---------- */
  function initMarquee() {
    var wrapper = document.querySelector('[data-marquee]');
    if (!wrapper) return;
    var track = wrapper.querySelector('.marquee-track');
    var content = wrapper.querySelector('.marquee-content');
    if (!track || !content) return;

    // Duplicate the content until the track is two identical halves, each at least as wide
    // as the bar — that's what makes the -50% keyframe loop seamless at any screen width.
    function fill() {
      while (track.children.length > 1) track.removeChild(track.lastChild);
      var half = Math.max(1, Math.ceil(wrapper.offsetWidth / Math.max(content.offsetWidth, 1)));
      var copies = Math.min(half * 2, 40);
      for (var i = 1; i < copies; i++) track.appendChild(content.cloneNode(true));
      var pxPerSecond = parseFloat(wrapper.getAttribute('data-speed')) || 60;
      wrapper.style.setProperty('--marquee-duration', (track.scrollWidth / 2 / pxPerSecond) + 's');
    }
    fill();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fill, 150); });
  }

  /* ---------- Homepage email/SMS signup → Klaviyo ---------- */
  function initSignupForm() {
    var forms = document.querySelectorAll('[data-signup-form]');
    if (!forms.length) return;
    Array.prototype.forEach.call(forms, function (form) {
      var key = form.getAttribute('data-klaviyo-key');
      var list = form.getAttribute('data-klaviyo-list');
      if (!key || !list) return; // not configured — onsubmit=return false keeps it inert

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.checkValidity()) { form.reportValidity(); return; }
        var btn = form.querySelector('button[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Signing up…'; }

        var val = function (n) { var el = form.querySelector('[name="' + n + '"]'); return el ? el.value : ''; };
        var source = form.getAttribute('data-source') || 'Homepage signup';
        var smsEl = form.querySelector('[name="sms_consent"]');
        var smsOptedIn = !!(smsEl && smsEl.checked);

        var rawPhone = val('phone');
        var phoneDigits = rawPhone.replace(/\D/g, '');
        var phoneE164 = '';
        if (phoneDigits.length === 10) { phoneE164 = '+1' + phoneDigits; }
        else if (phoneDigits.length === 11 && phoneDigits.charAt(0) === '1') { phoneE164 = '+' + phoneDigits; }

        var props = { 'Phone': rawPhone, 'SMS consent': (smsOptedIn ? 'Yes' : 'No'), 'Source': source };
        var postal = val('postal'); if (postal) { props['Postal code'] = postal; }
        var profile = { email: val('email'), properties: props };
        var firstName = val('first_name'); if (firstName) { profile.first_name = firstName; }
        if (phoneE164) { profile.phone_number = phoneE164; }

        var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key);
        var body = { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: profile } } }, relationships: { list: { data: { type: 'list', id: list } } } } };

        fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify(body) })
          .then(function (r) {
            if (r.ok) {
              var success = form.querySelector('[data-form-success]');
              Array.prototype.forEach.call(form.children, function (c) { if (c !== success) c.style.display = 'none'; });
              if (success) success.hidden = false;
            } else {
              r.text().then(function (t) { try { console.error('[CUBE] Klaviyo error', r.status, t); } catch (e) {} });
              if (btn) { btn.disabled = false; btn.innerHTML = original; }
              alert('Sorry — something went wrong. Please try again.');
            }
          })
          .catch(function (err) {
            try { console.error('[CUBE] Klaviyo request failed', err); } catch (e) {}
            if (btn) { btn.disabled = false; btn.innerHTML = original; }
            alert('Sorry — something went wrong. Please try again.');
          });
      });
    });
  }

  /* ---------- Product gallery: thumbnail → main swap ---------- */
  function initGallery() {
    var mainBox = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (!mainBox || !thumbs.length) return;
    var items = mainBox.querySelectorAll('.gallery-item');
    if (!items.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-media-id');
        items.forEach(function (it) {
          var match = it.getAttribute('data-media-id') === id;
          it.hidden = !match;
          var v = it.querySelector('video');
          if (v) {
            if (match && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else if (!match && v.pause) { v.pause(); }
          }
        });
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---------- Cart: instant AJAX remove + live count ---------- */
  function initCart() {
    var removes = document.querySelectorAll('[data-cart-remove]');
    var qtyBoxes = document.querySelectorAll('[data-qty]');
    if (!removes.length && !qtyBoxes.length) return;
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var shipBar = document.querySelector('[data-ship-bar]');
    var shipThreshold = shipBar ? (parseInt(shipBar.getAttribute('data-threshold'), 10) || 0) : 0;

    function setCount(n) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    }

    function updateShipBar(totalCents) {
      if (!shipBar || !shipThreshold) return;
      var msg = shipBar.querySelector('[data-ship-msg]');
      var fill = shipBar.querySelector('[data-ship-fill]');
      var remaining = shipThreshold - totalCents;
      if (fill) fill.style.width = Math.min(100, totalCents / shipThreshold * 100) + '%';
      shipBar.classList.toggle('ship-bar--unlocked', remaining <= 0);
      if (msg) msg.textContent = remaining <= 0
        ? "✓ You've unlocked free shipping!"
        : "You're $" + (remaining / 100).toFixed(2) + ' away from free shipping.';
    }

    function updateLinePrice(cart, key) {
      var item = null;
      for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { item = cart.items[i]; break; } }
      if (!item) return;
      var line = document.querySelector('[data-cart-line][data-line-key="' + key + '"]');
      var pe = line && line.querySelector('[data-line-price]');
      if (pe) pe.textContent = '$' + (item.final_line_price / 100).toFixed(2);
    }

    removes.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var line = link.closest('[data-cart-line]');
        var key = line ? line.getAttribute('data-line-key') : null;
        if (!key) { window.location.href = link.href; return; }
        link.textContent = 'Removing…';
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function (cart) {
            if (cart.item_count === 0) { window.location.reload(); return; }
            if (line && line.parentNode) line.parentNode.removeChild(line);
            if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
            updateShipBar(cart.total_price);
            setCount(cart.item_count);
          })
          .catch(function () { window.location.href = link.href; });
      });
    });

    // Quantity change → AJAX cart update (debounced so rapid +/- clicks send one request)
    qtyBoxes.forEach(function (box) {
      var input = box.querySelector('input');
      var line = box.closest('[data-cart-line]');
      var key = line ? line.getAttribute('data-line-key') : null;
      if (!input || !key) return;
      var t;
      input.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var q = Math.max(0, parseInt(input.value, 10) || 0);
          box.style.opacity = '0.5';
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: q })
          })
            .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
            .then(function (cart) {
              if (cart.item_count === 0) { window.location.reload(); return; }
              box.style.opacity = '';
              if (q === 0) { if (line && line.parentNode) line.parentNode.removeChild(line); }
              else { updateLinePrice(cart, key); }
              if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
              updateShipBar(cart.total_price);
              setCount(cart.item_count);
            })
            .catch(function () { window.location.reload(); });
        }, 350);
      });
    });
  }

  function init() {
    initDrawer();
    initAccordions();
    initSegmented();
    initQty();
    initProductForm();
    initPasswordForm();
    initSignupForm();
    initMarquee();
    initTruthCarousel();
    initStickyAtc();
    initGallery();
    initCart();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
